import { LanguageModel } from "hyer-flow-form";

const ptBRLanguageModel = {
  enterKey: "Enter",
  shiftKey: "Shift",
  ok: "OK",
  continue: "Continuar",
  skip: "Pular",
  pressEnter: "Pressione :enterKey",
  multipleChoiceHelpText: "Escolha quantas quiser",
  multipleChoiceHelpTextSingle: "Escolha apenas uma resposta",
  otherPrompt: "Outro",
  placeholder: "Escreva a sua resposta aqui...",
  submitText: "Enviar",
  longTextHelpText: ":shiftKey + :enterKey para quebrar a linha.",
  prev: "Anterior",
  next: "Proximo",
  percentCompleted: ":percent% completo",
  invalidPrompt: "Por favor, preencha o campo corretamente",
  thankYouText: "Obrigado!",
  successText: "Seu envio foi enviado!",
  ariaOk: "Aperte para continuar",
  ariaRequired: "Esse passo é obrigatório",
  ariaPrev: "Passo anterior",
  ariaNext: "Próximo passo",
  ariaSubmitTe: "Aperte para enviar",
  ariaMultipleChoice: "Pressione :letter para selecionar",
  ariaTypeAnswer: "Digite a sua resposta aqui",
};

export default new LanguageModel(ptBRLanguageModel);
